import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/blog.constant";

export {
    addMultipleBlogPosts,
    addSingleBlogPost,
    updateSingleBlogPost,
    getSingleBlogPost,
    searchBlogPosts,
    searchBlogPostsWithSearchCriteria,
    prepareBlogPostsList
}

const collectionName = 'blog-posts';
const collectionReference = collection(fireStoreDB, collectionName);

const addMultipleBlogPosts = (blogPosts) => {
    return Promise.map(blogPosts, async blogPost => {
        await addSingleBlogPost(blogPost);
    });
}

const addSingleBlogPost = (blogPost) => {
    blogPost.createdAt = new Date();
    blogPost.updatedAt = blogPost.createdAt;
    return addDoc(collectionReference, blogPost);
}

const updateSingleBlogPost = (blogPost) => {
    const documentReference = doc(fireStoreDB, collectionName, blogPost.id);
    blogPost.updatedAt = new Date();
    return setDoc(documentReference, blogPost);
}

const getSingleBlogPost = async (blogPostId) => {
    const documentReference = doc(fireStoreDB, collectionName, blogPostId);
    const blogPostDoc = await getDoc(documentReference);
    return prepareSingleBlogPost(blogPostDoc);
}

const searchBlogPosts = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const blogPostResult = await getDocs(searchQuery);
    return prepareBlogPostsList(blogPostResult);
}

const searchBlogPostsWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchBlogPostsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const blogPostResult = await getDocs(searchQuery);
    return prepareBlogPostsList(blogPostResult);
}

const prepareBlogPostsList = (blogPostResult) => {
    const blogPostsList = [];

    _.forEach(blogPostResult.docs, blogPostDoc => {
        blogPostsList.push(prepareSingleBlogPost(blogPostDoc));
    });

    return blogPostsList;
}

const prepareSingleBlogPost = (blogPostDoc) => {
    const blogPost = blogPostDoc.data();
    blogPost.id = blogPostDoc.id;
    return blogPost;
}
